/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {Store} from '@gongxigames/framework/core';
import {FC, CanBeSignals, getProp, $Sprite, $SetVisibility, $Button} from '@gongxigames/framework/core/fragments/BuilderY';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {$Button as $UIButton, BUTTON_STATES} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';
import {$VerticalListSelect} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/VerticalListSelect';
import {$Popup} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Popup';
import {slotStore} from '@gongxigames/framework/slotV2/globals/';
import {Circle, Rectangle} from 'pixi.js';
import {$UIText} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/UIText';

export type BetSelectBasePopupPops = CanBeSignals<{
    bets: number[];
    bet: number;
    show: boolean;
    faderAlpha?: number;
    onClose: () => void;
    onSetBetIndex: (index: number) => void;
    responsive: ResponsiveConf;
}>;

export const $BetSelectBasePopup: FC<BetSelectBasePopupPops> = (props) => {
    const index = Store.signal(0);

    const offBetUpdate = Store.effect(() => {
        index.value = getProp(props.bets).indexOf(getProp(props.bet));
    });

    function setTmpIndex(newIndex: number) {
        index.value = newIndex;
    }

    function submit() {
        getProp(props.onSetBetIndex)(index.value);
        getProp(props.onClose)();
    }

    function submitMaxBet() {
        const bets = getProp(props.bets);
        const max = Math.max(...bets);

        index.value = bets.indexOf(max);
        slotStore.soundPlayer.value?.play('betbuttonmax');
        submit();
    }

    const betList = Store.computed(() => {
        const currencyFormatter = slotStore.currencyFormatter.value!;

        return getProp(props.bets)
            .map(bet => currencyFormatter.formatCents(bet * slotStore.logic_wager.value));
    });

    const stateComponents = BUTTON_STATES.map(state =>{
        const stylePreset = state === 'focused' ? 'IN_BUTTON_TEXT_FOCUSED': 'IN_BUTTON_TEXT';
        const style = state === 'pressed' ? {fontSize: 76}: state === 'disabled' ? {fill: '#8d8d8d'} : undefined;

        return <$Sprite name={state} anchor={0.5} texture={`max_bet_${state}_sys_ui`}>
            <$UIText
                localeID='maxBetText'
                name='maxBetTextButton'
                stylePreset={stylePreset}
                style={style}
                maxWidth={480}
                maxHeight={90}
            />
        </$Sprite>;
    });

    return <$Popup
        responsiveConfig={props.responsive}
        headerId='betSelectHeader'
        show={props.show}
        onClose={props.onClose}
        faderAlpha={props.faderAlpha}
    >
        <$VerticalListSelect
            responsive={{
                box: {x: '50%', y: '168px'},
                translate: {x: '-50%'}
            }}
            height='800px'
            width='80%'
            values={betList}
            currentIndex={index}
            action={setTmpIndex}
            events={{destroyed: offBetUpdate}}
        />

        <$Button
            {...props}
            hitArea={new Rectangle(-252, -53, 504, 106)}
            name='max_bet'
            responsive={{
                box: {x: '50%', y: '100%'},
                translate: { y: '-348px'}
            }}
            action={submitMaxBet}
        >{(props) => {
                return <$SetVisibility selector={props.selector}>
                    {stateComponents}
                </$SetVisibility>;
            }}
        </$Button>

        <$UIButton
            hitArea={new Circle(0, 0, 188/2)}
            name='tick_btn'
            responsive={{
                box: {x: '50%', y: '100%'},
                translate: { y: '-144px'}
            }}
            action={submit}
        />
    </$Popup>;
};